import { $host } from './index';

export const getClinic = async () => {
  const { data } = await $host.get('web/clinic/');
  return data;
};

export const putClinic = async (clinic) => {
  const { data } = await $host.post('web/clinic/', clinic);
  return data;
};

export const changDoctorsVisibilityInBot = async (value) => {
  const { data } = await $host.post('web/clinic/show-all-doctors-in-bot', {value});
  return data;
};

export const changeDoctorButtonLayout = async (inTwoColumns) => {
  const { data } = await $host.post('web/clinic/doctor-button-layout', { inTwoColumns });
  return data;
};

export const changeServiceButtonLayout = async (inTwoColumns) => {
  const { data } = await $host.post('web/clinic/service-button-layout', { inTwoColumns });
  return data;
};

export const getDoctorExclusions = async () => {
  const { data } = await $host.get('web/clinic/doctor-exclusions');
  return data.exclusions;
};

export const saveDoctorExclusions = async (doctors) => {
  const { data } = await $host.post('web/clinic/doctor-exclusions', { doctors });
  return data;
};

export const getBranchExclusions = async () => {
  const { data } = await $host.get('web/clinic/branch-exclusions');
  return data.exclusions;
};

export const saveBranchExclusions = async (branches) => {
  const { data } = await $host.post('web/clinic/branch-exclusions', { branches });
  return data;
};

export const testSmsAero = async () => {
  const { data } = await $host.post('web/cascade/test-sms');
  return data;
};

export const getBranches = async () => {
  const { data } = await $host.get('web/clinic/branches');
  return data;
};

export const getMisBranches = async () => {
  const { data } = await $host.get('web/clinic/mis-branches');
  return data;
};


export const postBranch = async (branch) => {
  const { data } = await $host.post('web/clinic/branches', branch);
  return data;
};

export const syncBranches = async () => {
  const { data } = await $host.get('web/clinic/sync-branches');
  return data;
};

export const deleteBranch = async (id) => {
  const { data } = await $host.post('web/clinic/deletebranch', id);
  return data;
};

export const getAdmins = async () => {
  const { data } = await $host.get('web/clinic/admins');
  return data;
};

export const getDeletedAdmins = async () => {
  const { data } = await $host.get('web/clinic/admins-deleted');
  return data;
};

export const postAdmin = async (phone) => {
  const { data } = await $host.post('web/clinic/admins', phone);
  return data;
};

// export const postAdminId = async (id, isAdmin) => {
//   const { data } = await $host.post('web/clinic/adminsid', { id, isAdmin });
//   return data;
// };

export const deleteAdmin = async (id) => {
  const { data } = await $host.post('web/clinic/deleteadmin', id);
  return data;
};

export const restoreAdmin = async (id) => {
  const { data } = await $host.post('web/clinic/restore-admin', id);
  return data;
};

export const setAdminInternalName = async (adminId, internalName) => {
  const { data } = await $host.post('web/clinic/admin-internal-name', { adminId, internalName });
  return data;
};

// export const getDoctors = async () => {
//   const { data } = await $host.get('web/clinic/doctors');
//   return data;
// };
//
// export const postDoctor = async (phone) => {
//   const { data } = await $host.post('web/clinic/doctors', phone);
//   return data;
// };
//
// export const deleteDoctor = async (id) => {
//   const { data } = await $host.post('web/clinic/deletedoctor', id);
//   return data;
// };

export const getBotMessages = async () => {
  const { data } = await $host.get('web/clinic/botmessages');
  return data;
};

export const updateBotMessages = async () => {
  const { data } = await $host.get('web/clinic/updatebotmessages');
  return data;
};

export const postBotMessage = async (message) => {
  const { data } = await $host.post('web/clinic/botmessages', message);
  return data;
};
